{
    "Timezone_Title_Change": "Alterar fuso horário do usuário",
    "Timezone_Title_Update": "Atualizar fuso horário do usuário",
    "Timezone_Dropdown_Title": "Fuso horário",
    "Timezone_Tab_General": "Em geral",
    "Timeline_Prompt_Change": "Mudar",
    "Timeline_Prompt_Cancel": "Cancelar",
    "Timeline_Prompt_Change_Message": "Detectamos uma alteração no seu fuso horário de usuário \n \n Originalmente era **{}** \n \n Gostaria de alterar seu fuso horário local para **{}**",
    "Timeline_Prompt_First_Time_Message": "Seu fuso horário de relatórios atual está definido como **{}** \n \n Gostaria de atualizar seus relatórios para seu fuso horário local **{}**",
    "NAME": "TimezoneModal"
}